export const PrettyJson = {
  mounted() {
    this.prettifyJson(this.el)

    window.addEventListener("phx:prettify", (e) => {
      this.prettifyJson(this.el)
    })
  },

  updated() {
    this.prettifyJson(this.el)
  },

  prettifyJson(element) {
    let currentData = element.value.trim()
    try {
      let parsed = JSON.parse(currentData)

      element.value = JSON.stringify(parsed, null, 2)
    } catch (e) { }
  }
}
